// extracted by mini-css-extract-plugin
export default {"main":"d532eb7e64de"};